import { useCallback, useEffect } from 'react';
import { loadVariantCssVarMap } from '../components/cmv2/utils/globalStyles';
import { useFetchBulkVariants } from 'ContentData/queries/VariantQuery';
export const useLoadBulkVariantStyles = ({
  bulkVariantOverrides
}) => {
  const {
    data: bulkVariantsMap,
    loading
  } = useFetchBulkVariants();
  useEffect(() => {
    if (loading || !bulkVariantsMap) return;
    Object.keys(bulkVariantsMap).forEach(variantDefinitionName => {
      const variantDefinition = bulkVariantsMap[variantDefinitionName] || {};
      const variantDefinitionOverrides = (bulkVariantOverrides === null || bulkVariantOverrides === void 0 ? void 0 : bulkVariantOverrides[variantDefinitionName]) || {};
      if (variantDefinition) {
        loadVariantCssVarMap(variantDefinition, variantDefinitionOverrides);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, bulkVariantsMap]);
};
export const useLoadVariantStyles = ({
  variantDefinition
}) => {
  const _loadVariantCssVarMap = useCallback(newVariantDefinitionOverrides => {
    loadVariantCssVarMap(variantDefinition, newVariantDefinitionOverrides);
  }, [variantDefinition]);
  return {
    loadVariantCssVarMap: _loadVariantCssVarMap
  };
};